import { render, staticRenderFns } from "./ModelCreate.vue?vue&type=template&id=116f089c&"
import script from "./ModelCreate.vue?vue&type=script&lang=js&"
export * from "./ModelCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports